module.exports = {
      id: "Assistance-usage",
      viewBox: "0 0 35 35",
      url: __webpack_public_path__ + "../../../../skin/frontend/api/assets/mcp/svg/product/sprite.svg#Assistance-usage",
      toString: function () {
        return this.url;
      }
    }